import { usePOCManagement } from '@/hooks/admin/usePOCManagement';
import DeletePOCBaseDialog from './DeletePOCBaseDialog';

export function DeletePOCDialog({ poc, isOpen, onClose, onSuccess }) {
  const { removePOC } = usePOCManagement();

  const handleDelete = async () => {
    await removePOC(poc.id);
    onSuccess();
  };

  return (
    <DeletePOCBaseDialog
      poc={poc}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleDelete}
      title="Delete POC"
      confirmLabel="Delete POC"
    />
  );
}

export default DeletePOCDialog;
